import { Box, Typography } from '@mui/material';
import { useOrderingV2Ui } from 'src/contexts/ordering-v2-ui-context';
import { STORY_TILES } from './stories-config';

// ----------------------------------------------------------------------

export default function OrderV2StoriesRow() {
  const { openStory } = useOrderingV2Ui();

  return (
    <Box
      sx={{
        display: 'flex',
        gap: 2,
        overflowX: 'auto',
        pb: 2,
        mb: 2,
        mx: { xs: -2, md: -3 },
        px: { xs: 2, md: 3 },
        '&::-webkit-scrollbar': { height: 6 },
      }}
    >
      {STORY_TILES.map((tile) => (
        <Box
          key={tile.id}
          component="button"
          type="button"
          onClick={() => openStory(tile.id)}
          sx={{
            flex: '0 0 auto',
            width: { xs: 120, sm: 140 },
            aspectRatio: '1 / 1',
            borderRadius: '16px',
            border: 'none',
            cursor: 'pointer',
            p: 0,
            background: tile.gradient,
            position: 'relative',
            textAlign: 'left',
            boxShadow: '0 4px 16px rgba(0,0,0,0.08)',
            transition: 'transform 0.2s ease',
            '&:hover': { transform: 'scale(1.02)' },
            '&:focus-visible': { outline: '2px solid #0e7c62', outlineOffset: 2 },
          }}
        >
          <Typography
            sx={{
              position: 'absolute',
              bottom: 12,
              left: 12,
              right: 12,
              color: '#fff',
              fontWeight: 700,
              fontSize: 13,
              lineHeight: 1.2,
              textShadow: '0 1px 4px rgba(0,0,0,0.35)',
            }}
          >
            {tile.label}
          </Typography>
        </Box>
      ))}
    </Box>
  );
}
